import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isfArtifacts: []
};

export const MapIsfArtifacts = createSlice({
  name: 'MapIsfArtifacts',
  initialState,
  reducers: {
    clearMapIsfArtifacts: state => {
      state.isfArtifacts = [];
    },
    setMapIsfArtifacts: (state, action: PayloadAction<any>) => {
      state.isfArtifacts = action.payload;
    }
  }
});

export const { clearMapIsfArtifacts, setMapIsfArtifacts } = MapIsfArtifacts.actions;
